import { JSApi } from 'api'
import { AxiosPromise } from 'axios'
import { Embed } from 'types/embed'

export const getEmbedConfiguration = (id: string): AxiosPromise<Embed> => {
  return JSApi.get(`/embeds/${id}.json`)
}
